import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';

import ContentLoading from '~components/loading/ContentLoading';
import { PASS_SECTION_KEY } from '~constants/pass';
import useTransportProducts from '~queries/transportation/pointToPointTicket/useTransportProducts';
import { classifyProductsByCountry } from '~utils/pass/classifiedPassProducts';

import type { PassSectionKey } from '~types/pass';

import PassSection from './PassSection';

const PASS_SECTION_KEYS: Exclude<PassSectionKey, 'ALL'>[] = Object.values(PASS_SECTION_KEY).filter(
  (key) => key !== PASS_SECTION_KEY.ALL,
) as Exclude<PassSectionKey, 'ALL'>[];

interface Props {
  subscribe: (key: PassSectionKey) => (node: HTMLElement | null) => void;
}

const PassSectionList = ({ subscribe }: Props) => {
  const { data: transportProducts, isLoading, isError } = useTransportProducts();

  if (isError) {
    return null;
  }

  if (isLoading || !transportProducts) {
    return <ContentLoading />;
  }

  const productsByCountry = classifyProductsByCountry(transportProducts);

  const combinedPassKeys = [PASS_SECTION_KEY.ALL, ...PASS_SECTION_KEYS];
  return (
    <Container>
      {combinedPassKeys.map((key, index) => (
        <PassSection
          key={key}
          sectionKey={key}
          subscribe={subscribe}
          products={key === PASS_SECTION_KEY.ALL ? [] : productsByCountry[key]}
          sectionVerticalIndex={index}
          isLast={index === combinedPassKeys.length - 1}
        />
      ))}
    </Container>
  );
};

export default PassSectionList;

const Container = styled.div`
  padding: 0 20px;

  ${media.minMobile} {
    margin: 8px 0 172px;
    padding: 0;
  }
`;
